const zh_cn = {
  generate: "生成框架",
  back: "返回",
  theme_placeholder: "输入主题",
  theme: "内容框架",
  nums: "选择数量",
  language: "选择语言",
  empty: "无预览",
  enter: "打开PPT",
  pptEditorTips: "提示",
  pptSuccess: "PPT正在生成中...",
  go: "前往",
  about: "约",
  beforeDeleted: "确定要移除此章节吗?",
  beforeDeleted2: "确定要移除此活动吗?",
  cover: "封面标题",
  catalog: "目录",
  text: "正文",
  editOutline: "编辑框架",
  chapter: "章节",
  detailed: "输入详细描述",
  textSetting: "文本设置",
  toneSetting: "语气设置",
  themeSetting: "PPT主题设置",
  moreTheme: "更多主题",
  done: "生成PPT",
  doneAgain: "重新生成PPT",
  needText: "需要至少一段正文内容",
  needChapter: "需要至少一个章节",
  course: "课程大纲",
  beforeLeave: "返回不会保存框架内容",
  remarkTipsPPT: "重新生成，则会被删除原来的PPT",
  unfamiliar: "生词",
  copySuccess: "已添加到[我的教案]",
  beforeUse: "[我的教案]中已有同名教案，继续操作将会覆盖已有教案，继续吗",
  grammar: "语法",
  word: "字",
  activity: "活动",
  wordUnit: "个",
  sentencesUnit: "句",
  contentUnit: "段",
  clickToSelect: "选择主题",
  minePlan: "我的教案",
  sysPlan: "系统教案",
  publicPlan: "发布的试卷",
  createExam: "创建活动",
  type_name: "输入名称进行搜索",
  contentPages: "内容页数",
  numberOfTopics: "主题讨论数量",
  classification: "类型",
  courseName: "课程名称",
  pictureStyle: "图片风格",
  backgroundDesc: "背景详细描述",
  characterDesc: "角色详细描述",
  timeLimit: "回答问题时间",
  search: "搜索",
  uploadFileTips: "请上传原文文件",
  questionsAndAnswers: "生成阅读理解问答题",
  systemGeneration: "系统生成",
  originalTextGeneration: "原文生成",
  wordCount: "文章字数",
  systemScene: "系统场景",
  placeholderWordCount: "按原文字数",
  setFramework: "内容编辑",
  baseSetting: "基本设置",
  cancelCreatePPT: "当前生成PPT中，退出则取消生成，是否退出",
  optionRequired: "该选项为必选项",
  maxChapters: "PPT最多十个章节",
  generateTips: "PPT生成中，预计1-2分钟，请耐心等待",
  generateFaild: "PPT生成失败",
  Generating_outline: "正在生成大纲...",
  Preschool_activities: "学前活动",
  Preschool_activities_list: "学前活动列表",
  generateTimeout: "生成超时",
  noPpt: "暂未生成ppt",
  Generating: "正在生成..."
};

const zh_hant = {
  generate: "生成框架",
  back: "返回",
  theme_placeholder: "輸入主題",
  theme: "內容框架",
  nums: "選擇數量",
  language: "選擇語言",
  empty: "無預覽",
  enter: "打開PPT",
  pptEditorTips: "提示",
  pptSuccess: "PPT正在生成中...",
  go: "前往",
  about: "約",
  beforeDeleted: "確定要移除此章節嗎?",
  beforeDeleted2: "確定要移除此活動嗎?",
  cover: "封面標題",
  catalog: "目錄",
  text: "正文",
  editOutline: "編輯框架",
  chapter: "章節",
  detailed: "輸入詳細描述",
  textSetting: "文本設置",
  toneSetting: "語氣設置",
  themeSetting: "PPT主題設置",
  moreTheme: "更多主題",
  done: "生成PPT",
  doneAgain: "重新生成PPT",
  needText: "需要至少一段正文內容",
  needChapter: "需要至少一個章節",
  course: "課程大綱",
  beforeLeave: "返回不會保存框架内容",
  remarkTipsPPT: "重新生成，則會刪除原來的PPT",
  unfamiliar: "生詞",
  copySuccess: "已添加到[我的教案]",
  beforeUse: "[我的教案]中已有同名教案，繼續操作將會覆蓋已有教案，繼續嗎",
  grammar: "語法",
  word: "字",
  activity: "活動",
  wordUnit: "個",
  sentencesUnit: "句",
  contentUnit: "段",
  clickToSelect: "選擇主題",
  minePlan: "我的教案",
  sysPlan: "系統教案",
  publicPlan: "發佈的試卷",
  createExam: "創建活動",
  type_name: "輸入名稱進行搜索",
  contentPages: "内容頁數",
  numberOfTopics: "主題討論數量",
  classification: "類型",
  courseName: "課程名稱",
  pictureStyle: "圖片風格",
  backgroundDesc: "背景詳細描述",
  characterDesc: "角色詳細描述",
  timeLimit: "回答問題時間",
  search: "搜索",
  uploadFileTips: "請上傳原文文件",
  questionsAndAnswers: "生成閱讀理解問答題",
  systemGeneration: "系統生成",
  originalTextGeneration: "原文生成",
  wordCount: "文章字數",
  systemScene: "系統場景",
  placeholderWordCount: "按原文字數",
  setFramework: "内容編輯",
  baseSetting: "基本設置",
  cancelCreatePPT: "當前生成PPT中，退出則取消生成，是否退出",
  optionRequired: "該選項為必選項",
  maxChapters: "PPT最多十個章節",
  generateTips: "PPT生成中，預計1-2分鐘，請耐心等待",
  generateFaild: "PPT生成失敗",
  Generating_outline: "正在生成大綱...",
  Preschool_activities: "學前活動",
  Preschool_activities_list: "學前活動列表",
  generateTimeout: "生成超時",
  noPpt: "暫未生成ppt",
  Generating: "正在生成..."
};

const en = {
  generate: "Generate",
  back: "Back",
  theme_placeholder: "Input keywords",
  theme: "Content Framework",
  nums: "No. of options",
  language: "Language",
  empty: "No preview",
  enter: "Open PPT",
  pptEditorTips: "Notice",
  pptSuccess: "PPT is being generated",
  go: "Go",
  about: " ",
  beforeDeleted: "Are you sure you want to remove this chapter?",
  beforeDeleted2: "Are you sure you want to remove this activity?",
  cover: "Cover Title",
  catalog: "Contents",
  text: "Text",
  editOutline: "Edit Outline",
  chapter: "Chapter ",
  detailed: "Enter a detailed description",
  textSetting: "Text Settings",
  toneSetting: "Tone Settings",
  themeSetting: "PPT theme settings",
  moreTheme: "More Themes",
  done: "Generate",
  doneAgain: "Regenerate",
  needText: "At least one piece of text needs to be retained",
  needChapter: "At least one piece of chapter needs to be retained",
  course: "Course Outline",
  beforeLeave: "Returning will not save the framework",
  remarkTipsPPT: "If the PPT is regenerated, the original PPT will be deleted",
  unfamiliar: "Vocabulary",
  copySuccess: "Success",
  beforeUse:
    "There is already a plan with the same name in [My Class Plan]. If you continue, the existing plan will be overwritten. Do you want to continue?",
  grammar: "Grammar",
  word: "word(s)",
  activity: "Activity",
  wordUnit: "words",
  sentencesUnit: "sentences",
  contentUnit: "paragraphs",
  clickToSelect: "Choose a theme",
  minePlan: "My Lesson Plans",
  sysPlan: "Systematic Lesson Plans",
  publicPlan: "Published papers",
  createExam: "Create Activities",
  type_name: "Type name to search",
  contentPages: "No. of Pages",
  numberOfTopics: "No. of Discussion Topics",
  classification: "Type",
  courseName: "Lesson Title",
  pictureStyle: "Image Style",
  backgroundDesc: "Background Description",
  characterDesc: "Character Description",
  timeLimit: "Answering Time",
  search: "Search",
  uploadFileTips: "Please upload the original file",
  questionsAndAnswers: "Comprehension - Questions",
  systemGeneration: "AI Generated",
  originalTextGeneration: "AI Generated from Original Text",
  wordCount: "Word Count",
  systemScene: "System Scenario",
  placeholderWordCount: "Original word count",
  setFramework: "Content editing",
  baseSetting: "Basic Settings",
  cancelCreatePPT:
    "Currently generating PPT, if you exit, the generation will be cancelled. Whether to exit or not",
  optionRequired: "This option is a required one",
  maxChapters: "Up to ten chapters",
  generateTips:
    "PPT is being generated and is expected to take 1-2 minutes. Please be patient and wait",
  generateFaild: "PPT generation failed",
  Generating_outline: "Generating outline...",
  Preschool_activities: "Preschool activities",
  Preschool_activities_list: "List of Preschool Activities",
  generateTimeout: "generate Timeout",
  noPpt: "Not yet generated ppt",
  Generating: "Generating..."
};

const es = {
  generate: "Generar IA",
  back: "Atrás",
  theme_placeholder: "Ingresar palabras clave",
  theme: "Estructura del contenido",
  nums: "Número de opciones",
  language: "Idioma",
  empty: "Sin vista previa",
  enter: "Abrir PPT",
  pptEditorTips: "Aviso",
  pptSuccess: "PPT está siendo generado",
  go: "Ir",
  about: "",
  beforeDeleted: "¿Estás seguro de que deseas eliminar este capítulo?",
  beforeDeleted2: "¿Estás seguro de que deseas eliminar esta actividad?",
  cover: "Título de la Portada",
  catalog: "Tabla de Contenidos",
  text: "Texto",
  editOutline: "Editar esquema",
  chapter: "Capítulo",
  detailed: "Ingresar una descripción detallada",
  textSetting: "Configuración de Texto",
  toneSetting: "Configuración de Tono",
  themeSetting: "Configuración de tema de PPT",
  moreTheme: "Más temas",
  done: "Generar ppt",
  doneAgain: "Regenerar ppt",
  needText: "Al menos un fragmento de texto debe mantenerse",
  needChapter: "Al menos un fragmento del capítulo debe mantenerse",
  course: "Esquema del curso",
  beforeLeave: "Volver atrás no guardará el esquema",
  remarkTipsPPT: "Reconstruir el esquema eliminará el PPT original",
  unfamiliar: "Vocabulario",
  copySuccess: "Éxito",
  beforeUse:
    "Ya existe un plan con el mismo nombre en [Mi Plan de Clase]. Si continúas, el plan existente será sobrescrito. ¿Quieres continuar?",
  grammar: "Gramática",
  word: "palabra(s)",
  activity: "Actividad",
  wordUnit: "palabras",
  sentencesUnit: "oraciones",
  contentUnit: "Párrafo",
  clickToSelect: "Elegir un tema",
  minePlan: "Mi Planes de lecciones",
  sysPlan: "Planes de lecciones sistemáticos",
  publicPlan: "Artículos publicados",
  createExam: "Crea Actividades",
  type_name: "Nombre a buscar",
  contentPages: "Páginas de contenido",
  numberOfTopics: "El número de discusiones de tema",
  classification: "Tipo",
  courseName: "Nombre de la lección",
  pictureStyle: "Estilo de imagen",
  backgroundDesc: "Antecedentes Descripción",
  characterDesc: "Descripción del personaje",
  timeLimit: "Tiempo de respuesta",
  search: "Buscar",
  uploadFileTips: "Por favor, sube el archivo de texto original",
  questionsAndAnswers: "Comprensión - Preguntas",
  systemGeneration: "Generación IA",
  originalTextGeneration: "Generación IA con texto original",
  wordCount: "Recuento de palabras del artículo",
  systemScene: "Escena del sistema",
  placeholderWordCount: "Según el original",
  setFramework: "Edición de contenido",
  baseSetting: "Configuración básica",
  cancelCreatePPT:
    "Actualmente se está generando el PPT. Si sales, la generación se cancelará. ¿Quieres salir?",
  optionRequired: "Esta opción es obligatoria",
  maxChapters: "Ppt hasta diez capítulos",
  generateTips: "En la generación de ppt, se espera 1 - 2 minutos, por favor espere pacientemente",
  generateFaild: "Falló la generación de ppt",
  Generating_outline: "Se está generando un esquema. ......",
  Preschool_activities: "Actividades preclase",
  Preschool_activities_list: "Lista de actividades preclase",
  generateTimeout: "Horas extras",
  noPpt: "Aún no se ha generado ppt",
  Generating: "Se está generando..."
};

export default {
  en,
  zh_hant,
  es,
  zh_cn
};
